import type { AppModule } from '@/types/architecture'

// Import all module configs
// These will be auto-discovered in a production setup
// For now, we import them explicitly

const moduleConfigs = import.meta.glob<{ default: AppModule }>(
    '../modules/*/index.ts',
    { eager: true }
)

/**
 * Load all registered modules
 * Auto-discovers modules from src/modules/{name}/index.ts
 */
export function loadModules(): { modules: AppModule[]; routes: AppModule['routes'] } {
    const modules: AppModule[] = []
    const routes: AppModule['routes'] = []

    for (const path in moduleConfigs) {
        const module = moduleConfigs[path].default
        if (module && module.id) {
            modules.push(module)
            routes.push(...module.routes)
        }
    }

    // Sort by navigation order
    modules.sort((a, b) => a.navigation.order - b.navigation.order)

    return { modules, routes }
}

/**
 * Get a specific module by ID
 */
export function getModuleById(id: string): AppModule | undefined {
    const { modules } = loadModules()
    return modules.find(m => m.id === id)
}
